import React from 'react';
import type { TeamMembers } from '../types';
import { getTeamTheme, teamImageSrc } from '../teamTheme';
import { publicSrc } from '../assets';
import { WinnerCrown } from './WinnerCrown';

interface TeamListProps {
   teams: TeamMembers;
   winners?: string[];
   trophySrc?: string;
}

export function TeamList({ teams, winners = [], trophySrc }: TeamListProps) {
   const teamNames = Object.keys(teams);
   const trophyImage = trophySrc ? publicSrc(trophySrc) : '';

   return (
      <section className="swamp-section">
         <h2 className="swamp-section__title">Teams</h2>
         <ul className="swamp-team-list">
            {teamNames.map((teamName) => {
               const theme = getTeamTheme(teamName);
               const imageSrc = teamImageSrc(teamName);
               const isWinner = winners.includes(teamName);

               return (
                  <li
                     key={teamName}
                     className={`swamp-team-card${isWinner ? ' swamp-team-card--winner' : ''}`}
                     style={{ borderColor: isWinner ? undefined : theme.color }}
                  >
                     {imageSrc && (
                        <img
                           src={imageSrc}
                           alt=""
                           className="swamp-team-card__image"
                        />
                     )}
                     <div className="swamp-team-card__heading">
                        {isWinner && trophyImage && (
                           <img
                              src={trophyImage}
                              alt=""
                              className="swamp-team-card__trophy"
                           />
                        )}
                        <h3 className="swamp-team-card__name" style={{ color: theme.color }}>
                           {teamName}
                        </h3>
                        {isWinner && <WinnerCrown className="swamp-team-card__crown" />}
                     </div>
                     <ul className="swamp-team-card__members">
                        {teams[teamName].map((member) => (
                           <li key={member}>{member}</li>
                        ))}
                     </ul>
                  </li>
               );
            })}
         </ul>
      </section>
   );
}
